// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.party[data-v-85a6e8ba] {\n\tbackground: #f9f9f9;\n\tpadding: 12px 16px;\n\tborder-radius: 6px;\n\tborder: 1px solid #e8e8e8;\n\tline-height: 1.6;\n}\n.party-name[data-v-85a6e8ba] {\n\tfont-weight: 600;\n\tcolor: #333;\n\tmargin-bottom: 4px;\n}\n.party-vat[data-v-85a6e8ba] {\n\tmargin-top: 4px;\n\tfont-size: 12px;\n\tcolor: #666;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
